// extracted by mini-css-extract-plugin
export default {"contactButton":"button_contactButton__n8hiE","ripple":"button_ripple__QWXGx"};